import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("mixnsmash", "Mix N' Smash", "img/projects/mixnsmash2.png", `
    <div class="paragraph">
        <strong>Mix N' Smash</strong> is a fast paced puzzle game where the player has to, you guessed it, mix and smash geometric figures in order to achieve the goal of each level.
        <div class="paragraph">
            Main mechanic:
            <ul>
            <li>Smashing the same shapes of the same color into each other, destroys both.</li>
            <li>Smashing shapes the same shapes of different colors into each other, mixes their colors.</li>
            <li>Smashing different shapes into each other, applies the ability of the shape with the lowest speed into the other shape.</li>
            <li>Each shape has unique abilities. E.g: Triangles invert the colors and Circles are portals!</li>
        </ul>
    </div>
    </div>

    <div class="paragraph center">
        <a href="https://dannyisyog.itch.io/mixnsmash-shape-shepard" target="_blank"><img src="img/projects/badge-color.svg" alt="Itch.io Badge" /></a>
    </div>
    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Main Mechanics Design</li>
        <li>Level Design</li>
        <li>UI/UX Design</li>
        <li>Game Loop implementations</li>
        <li>UI/UX implementations</li>
        </ul>
    </div>
    <div class="paragraph">
        Design Goals:
        <ul>
        <li>Fast Paced gameplay/gameflow</li>
        <li>Color Mixing and Shape Smashing</li>
        <li>Simplistic shapes themed/visuals</li>
        <li>Everything is bouncy and has bouncy animation</li>
        </ul>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMjA1MzU1OS8xMjA4NzMzMS5wbmc=/original/V19df3.png" alt="Mix N Smash Screenshot" />
    <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMjA1MzU1OS8xMjA4NzMzMy5wbmc=/794x1000/mdXBOj.png" alt="Mix N Smash Screenshot" />
    </div>
    `, "#150e23", true, false, false, ["Puzzle", "Unity", "C#"]),

    new ProjectData("starLoop", "Star Loop", "img/projects/starloop.gif",
    `
    <div class="paragraph">
     <strong>Star Loop</strong> is a one button puzzle game where the player controls a spaceship throughout the vastness of the universe using wormholes.
     The player controls a spaceship with two thruster motors, which would let the player move in a straight line if both are on — but the travel through the wormhole causes irreparable damage to them and the player can only have one on at a time. This leads to a wave-like movement where the player will switch between clockwise and counterclockwise movement.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/O13ch4R4O4E" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="https://dannyisyog.itch.io/star-loop" target="_blank"><img src="img/projects/badge-color.svg" alt="Itch.io Badge" /></a>
    </div>

    <div class="paragraph">
        Main features:
        <ul>
        <li>Explore different star systems</li>
        <li>Infinite number of strategies to beat the game</li>
        <li>High difficulty to give a high sense of completion</li>
        </ul>
    </div>

    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Main Mechanics Design</li>
        <li>Enemies Design</li>
        <li>Game Loop implementations</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="phone-screenshot" src="https://img.itch.zone/aW1hZ2UvMTUwOTc0Mi84ODA1NDA3LnBuZw==/original/fcMANc.png" alt="Level Screenshot" />
        <img class="phone-screenshot" src="https://img.itch.zone/aW1hZ2UvMTUwOTc0Mi84ODA1NDIwLnBuZw==/794x1000/DrZGLD.png" alt="Last Level Screenshot" />
    </div>
    `, "#9de486", false, false, false, ["Puzzle", "Mobile", "Unity"]),

    new ProjectData("smashcart", "Smashcart Ultra", "img/projects/smashcart.png", `
    <div class="paragraph">
        <strong>Smashcart Ultra</strong> is an online multiplayer party game where you take control of a crazy shopping cart through several shopping centers in different and fun mini-games!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/vno0eVthCLU" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Mini Games Design</li>
        <li>Game Loop implementation</li>
        <li>Online/Local multiplayer Implementation</li>
        </ul>
    </div>
    <div class="paragraph">
        Main features:
        <ul>
        <li>Short, Fast Paced and Chaotic Game Modes</li>
        <li>Shopping Themed</li>
        <li>Cart Customization</li>
        <li>And then some</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvODg5MjgxLzUwMjI0ODQuZ2lm/794x1000/Psxf4z.gif" alt="Smashcart Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvODg5MjgxLzUwMTYxNTEucG5n/794x1000/gk%2FC67.png" alt="Smashcart Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvODg5MjgxLzUwMTYwNzAucG5n/794x1000/sl8dd6.png" alt="Smashcart Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvODg5MjgxLzUwMTYxNTIucG5n/794x1000/qNfC0S.png" alt="Smashcart Screenshot" />
    </div>
    `, "#E70016", false, false, false, ["Multiplayer", "Party", "Unity"]),

    new ProjectData("rootie", "Rootie & Twootie", "img/projects/rootie.png", `
    <div class="paragraph">
    <strong>Rootie and Twootie</strong> get up to even more shenanigans! When the evil Math Magician kidnaps our two protagonists for his nefarious deeds, help our ragtag duo escape, free the numbers and maybe even come up with their best nerdy puns along the way.
    An educational experience with a side of silly fun, made for GGJ 2023 with the theme "Roots".
    </div>

    <div class="paragraph center">
        <a href="https://dannyisyog.itch.io/rootie-twootie-operation-chaos-and-the-rogue-numbers-3" target="_blank"><img src="img/projects/badge-color.svg" alt="Itch.io Badge" /></a>
    </div>

    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Main Mechanics Design</li>
        <li>Level Design</li>
        <li>Game Loop Implementation</li>
        <li>Character Controller Implementation</li>
        <li>Local Multiplayer Implementation</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMTkxMDYyNS8xMTI3NzY0OS5wbmc=/794x1000/v65psS.png" alt="Rootie Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMTkxMDYyNS8xMTI3NzY0OC5wbmc=/794x1000/OSKm77.png" alt="Rootie Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMTkxMDYyNS8xMTI3NzY1MC5wbmc=/794x1000/asSN6R.png" alt="Rootie Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMTkxMDYyNS8xMTI3Nzk1MS5wbmc=/794x1000/KFYS8y.png" alt="Rootie Screenshot" />
    </div>
    `, "#d9f3d8", false, false, false, ["Educational", "Co-op", "Game Jam"]),

    new ProjectData("eyenucleation", "Eyenucleation", "img/projects/eyenucleation.png", `
    <div class="paragraph">
        Imagine a character that can remove his own eyes... Crazy right? Well, in Ancient Egypt anything is possible! Use your own eyes to solve the puzzles as Tuta in order to pass the levels! Look at every Eye of Horus in a single room to open the door and proceed!
    </div>
    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Level Design</li>
        </ul>
    </div>
    <div class="paragraph">
        Main features:
        <ul>
        <li>4 Levels</li>
        <li>Each has its own camera (yes the screen splits!)</li>
        <li>Throwable eyes</li>
        </ul>
    </div>

    <div class="paragraph center">
        <a href="https://keeptrying.itch.io/eyenucleation" target="_blank"><img src="img/projects/badge-color.svg" alt="Itch.io Badge" /></a>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://media.discordapp.net/attachments/711620289913421985/1146846127367409784/Screenshot_1.png?width=1992&height=1325" alt="Eyenucleation Screenshot" />
        <img class="pc-screenshot" src="https://media.discordapp.net/attachments/711620289913421985/1146846127879106661/Screenshot_2.png?width=2022&height=1325" alt="Eyenucleation Screenshot" />
    </div>`, "#ffb020", false, false, false, ["Puzzle", "Game Jam", "Unity"]),

    new ProjectData("feedinov", "Quinta do Vale", "img/projects/feedinov.png", `
    <div class="paragraph">
    This week you received a letter from a distant and mysterious relative. The letter informs you that you've inherited a farm, but it seems that things aren't going very well there...
    Get to work! With Pixel and your new neighbors, help bring the farm back to its former glory. Learn about sustainability, animals and their importance in the world while trying to manage all the components involved!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/i8bEcw6v6io" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Game Design</li>
        <li>Mini Games Design</li>
        <li>Mini Games Implementation</li>
        </ul>
    </div>
    <div class="paragraph">
        Main features:
        <ul>
        <li>Real Time Farm Management</li>
        <li>4 Different Animals</li>
        <li>10 Different Minigames</li>
        <li>25 Narrative Events</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://lh3.googleusercontent.com/FtPafrIdncM8748hXjY3uSogKaxUl-tow1VGkx-11Q7ZAnBuun6ouOH69XsmUJuF6kE" alt="Quinta do Vale Screenshot" />
        <img class="pc-screenshot" src="https://lh3.googleusercontent.com/aYtlxQDmQcX2xtXCwWGuG6u6hdKb8mvwyVFiPUrZafZlaMGTmZCSK0PRvUJpLzQJZMg" alt="Quinta do Vale Screenshot" />
        </div>`, "#f07f3e", false, false, false, ["Educational", "Mobile", "Godot"]),

    new ProjectData("ridingholy", "Riding Holy", "img/projects/ridingholy.png", `
    <div class="paragraph">
    Riding Holy is a game about a Priest that kills vampires while performing skateboard tricks.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/BTCVVHV4sKc" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="https://dannyisyog.itch.io/riding-holy" target="_blank"><img src="img/projects/badge-color.svg" alt="Itch.io Badge" /></a>
    </div>
    <div class="paragraph">
        My Contributions for this game:
        <ul>
        <li>Game Design</li>
        <li>Combat Design</li>
        <li>Producer</li>
        </ul>
    </div>
    <div class="paragraph">
        Main features:
        <ul>
        <li>Skateboards with different abilities for various playstyles</li>
        <li>Tons of enemies</li>
        <li>All the skateboard tricks you can imagine</li>
        <li>World building based on a skateboard religion</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMjE4NzkwMy8xMzE1NjA4MC5wbmc=/794x1000/THINzW.png" alt="Riding Holy Screenshot" />
        <img class="pc-screenshot" src="https://img.itch.zone/aW1hZ2UvMjE4NzkwMy8xMzE1NjA4Mi5wbmc=/794x1000/VJswLq.png" alt="Riding Holy Screenshot" />
        </div>`, "#ff5000", false, false, false, ["Action", "Game Jam", "Unity"]),

    new ProjectData("cubos.", "CUBOS.", "img/projects/cubos.png", `
        <div class="paragraph">
        CUBOS. aims to be a simple, but powerful game engine for PC, where everything is made out of voxels.

        It is open source and free to use for any purpose. Written in modern C++ (20) and with data-oriented design in mind, its goal is to be both performant and highly flexible.

        <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/KfsEuGJDU2I" frameborder="0" allowfullscreen></iframe>
        </div>

        <div class="paragraph center">
            <a href="https://github.com/GameDevTecnico/cubos" target="_blank"><img src="img/projects/github.png" alt="GitHub" /></a>
        </div>
        <div class="paragraph">
            My Contributions for this engine:
            <ul>
            <li>Input System (old, has since been replaced)</li>
            <li>ECS - Entity Component System (Base)</li>
            </ul>
        </div>
        <div class="paragraph">
            Main features:
            <ul>
            <li>Voxels</li>
            <li>Destructibility</li>
            <li>Data-oriented over Object-oriented design — ECS based</li>
            <li>Built from scratch using C++/OpenGL</li>
            <li>Open Source</li>
            </ul>
        </div>`, "#22272e", false, false, false, ["Engine", "C++", "Open Source"])
];
